// @flow

export default (input: string): string => input.toLowerCase().replace(/[^a-zA-Z0-9-]/g, '');
